import type { GetStaticPaths, GetStaticProps } from 'next'

import { WordPressApiClient } from '@/utils/WordPressApiClient'

import type { NewsRelease } from '@/types/newsRelease'

export { NewsArticlePage as default } from '@/components/pages/News/Release/NewsId'

export const getStaticPaths: GetStaticPaths = async () => {
  const wpClient = new WordPressApiClient()
  const newsRelease = await wpClient.fetchNewsRelease()

  const paths = newsRelease.map((item: any) => ({
    params: { newsId: item._id },
  }))

  return {
    paths,
    fallback: false,
  }
}

type Props = {
  news: NewsRelease
}

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const wpClient = new WordPressApiClient()
  const news = await wpClient.fetchNews(`${params?.newsId}`)

  return {
    props: {
      news,
    },
  }
}
